const Helpers = (function () {
  let helperFunctions = {};

  helperFunctions.currencyFormater = new Intl.NumberFormat(
    'fr-FR',
    { style: 'currency', currency: 'EUR', maximumFractionDigits: 2 }
  );
  helperFunctions.integerCurrencyFormater = new Intl.NumberFormat(
    'fr-FR',
    { style: 'currency', currency: 'EUR', minimumFractionDigits: 0, maximumFractionDigits: 0 }
  );
  helperFunctions.percentFormater = new Intl.NumberFormat(
    'fr-FR',
    { style: 'percent', minimumFractionDigits: 1, maximumFractionDigits: 2 }
  );

  helperFunctions.debounce = (callback, delay) => {
    var timer;

    return function () {
      var args = arguments;
      var context = this;

      clearTimeout(timer);

      timer = setTimeout(function () {
        callback.apply(context, args);
      }, delay);
    };
  };

  return helperFunctions;
})();

export default Helpers

// Expose top-level declarations as globals (pre-bundler concatenation behavior).
window.Helpers = Helpers;
